<template>
	<div class="wrapper">
		<global-state-aggregator-wom-watcher
			v-for="(wom, womIndex) in WOMs"
			:key="wom.$internals.metaProperties.meta.guid"
			:WOM="wom"
			@triggerReCalc="triggerReCalc" />
	</div>
</template>
<script>
import GlobalStateAggregatorWOM from "js/data-store/state-management/global-state-aggregator-wom.js";
import GlobalStateAggregatorWomWatcher from "vue/sheet-views/common/global-state-aggregators/global-state-aggregator-wom-watcher.vue";
export default {
	$pubsub: {},
	components: {
		GlobalStateAggregatorWomWatcher
	},
	props: {
		dataStore: {
			required: false
		}
	},
	created() {
		GlobalStateAggregatorWOM.init(); // Even if this was created before, just re initialize it to remove any nulls
	},
	destroyed() {
		GlobalStateAggregatorWOM.init(); // Remove all stale wom references to avoid future data collisions if the user changes workbook
	},
	data() {
		return {
			state: GlobalStateAggregatorWOM.state,
			womState: {},
			cells: {},
			womsToCells: {}
		}
	},
	methods: {
		setStructure() {
			if (this.structuredRequirements.records) {
				GlobalStateAggregatorWOM.setStructure(this.structuredRequirements);
			}
		},
		triggerReCalc() {
			let WOMs = [];
			if (this.dataStore) {
				WOMs = this.dataStore.WOMs;
				// Calculate aggregations
				this.setStructure();
				GlobalStateAggregatorWOM.populate({ WOMs, dataStore: this.dataStore });
				// Return the woms to whatever actually needs it
				return WOMs;
			}
			return [];
		}
	},
	computed: {
		structuredRequirements() {
			return {
				records: this.dataStore ? this.dataStore.records : null,
				fields: this.dataStore ? this.dataStore.meta.schema.fields : null
			}
		},
		WOMs() {
			return this.triggerReCalc();
		}
	}
}
</script>
<style lang="scss" scoped>
div.wrapper {
	display: none;
}
</style>